var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _rect34, _path, _rect35;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgThumbnail1A(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 328,
    height: 225,
    viewBox: "0 0 328 225",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 328,
    height: 225,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 9.50732,
    y: 18.8306,
    width: 57.0435,
    height: 4.6875,
    fill: "#E0E0E0"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 133.102,
    y: 18.8306,
    width: 57.0435,
    height: 4.6875,
    fill: "#E0E0E0"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 71.3042,
    y: 18.8306,
    width: 57.0435,
    height: 4.6875,
    fill: "#E0E0E0"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 194.898,
    y: 18.8306,
    width: 57.0435,
    height: 4.6875,
    fill: "#E0E0E0"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 9.50732,
    y: 164.257,
    width: 48.9092,
    height: 13.125,
    stroke: "#CCCCCC"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 58.416,
    y: 164.257,
    width: 260.076,
    height: 13.125,
    stroke: "#CCCCCC"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 9.50732,
    y: 156.665,
    width: 48.9092,
    height: 7.58929,
    fill: "#EEEEEE",
    stroke: "#CCCCCC"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 58.416,
    y: 156.665,
    width: 260.076,
    height: 7.58929,
    fill: "#EEEEEE",
    stroke: "#CCCCCC"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 9.50732,
    y: 134.03,
    width: 48.9092,
    height: 13.125,
    stroke: "#CCCCCC"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 107.325,
    y: 134.029,
    width: 48.9092,
    height: 13.125,
    stroke: "#CCCCCC"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 58.416,
    y: 134.029,
    width: 48.9092,
    height: 13.125,
    stroke: "#CCCCCC"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 156.234,
    y: 134.029,
    width: 48.9092,
    height: 13.125,
    stroke: "#CCCCCC"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 205.143,
    y: 134.029,
    width: 48.9092,
    height: 13.125,
    stroke: "#CCCCCC"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 9.50732,
    y: 126.438,
    width: 48.9092,
    height: 7.58929,
    fill: "#EEEEEE",
    stroke: "#CCCCCC"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 107.325,
    y: 126.438,
    width: 48.9092,
    height: 7.58929,
    fill: "#EEEEEE",
    stroke: "#CCCCCC"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 58.416,
    y: 126.438,
    width: 48.9092,
    height: 7.58929,
    fill: "#EEEEEE",
    stroke: "#CCCCCC"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 156.234,
    y: 126.438,
    width: 48.9092,
    height: 7.58929,
    fill: "#EEEEEE",
    stroke: "#CCCCCC"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 205.143,
    y: 126.438,
    width: 48.9092,
    height: 7.58929,
    fill: "#EEEEEE",
    stroke: "#CCCCCC"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 282.059,
    y: 134.029,
    width: 36.4339,
    height: 13.125,
    stroke: "#CCCCCC"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 254.052,
    y: 134.029,
    width: 28.0061,
    height: 13.125,
    stroke: "#CCCCCC"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 282.059,
    y: 126.438,
    width: 36.4339,
    height: 7.58929,
    fill: "#EEEEEE",
    stroke: "#CCCCCC"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 254.052,
    y: 126.438,
    width: 28.0061,
    height: 7.58929,
    fill: "#EEEEEE",
    stroke: "#CCCCCC"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 9.50732,
    y: 31.0181,
    width: 308.986,
    height: 1.875,
    fill: "#E0E0E0"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 9.50732,
    y: 42.2681,
    width: 128.323,
    height: 4.6875,
    fill: "#E0E0E0"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 9.50732,
    y: 63.9221,
    width: 115.664,
    height: 53.0063,
    stroke: "#CCCCCC"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 9.50732,
    y: 56.3306,
    width: 115.664,
    height: 7.58929,
    fill: "#EEEEEE",
    stroke: "#CCCCCC"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 254.052,
    y: 63.9219,
    width: 64.4401,
    height: 53.0063,
    stroke: "#CCCCCC"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 189.612,
    y: 63.9219,
    width: 64.4401,
    height: 53.0063,
    stroke: "#CCCCCC"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 125.172,
    y: 63.9219,
    width: 64.4401,
    height: 53.0063,
    stroke: "#CCCCCC"
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 254.052,
    y: 56.3306,
    width: 64.4401,
    height: 7.58929,
    fill: "#EEEEEE",
    stroke: "#CCCCCC"
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 189.612,
    y: 56.3306,
    width: 64.4401,
    height: 7.58929,
    fill: "#EEEEEE",
    stroke: "#CCCCCC"
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 125.172,
    y: 56.3306,
    width: 64.4401,
    height: 7.58929,
    fill: "#EEEEEE",
    stroke: "#CCCCCC"
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    x: 258.806,
    y: 68.606,
    width: 54.9329,
    height: 43.6376,
    fill: "#E0E0E0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M295.78 85.0868C295.78 84.1234 294.963 83.3081 293.998 83.3081H290.729L290.247 82.1223C289.987 81.4183 289.318 80.9365 288.575 80.9365H283.933C283.19 80.9365 282.522 81.4183 282.262 82.1223L281.816 83.3081H278.548C277.546 83.3081 276.766 84.1234 276.766 85.0868V95.7591C276.766 96.7596 277.546 97.5378 278.548 97.5378H293.998C294.963 97.5378 295.78 96.7596 295.78 95.7591V85.0868ZM290.729 90.423C290.729 92.9057 288.724 94.8697 286.273 94.8697C283.785 94.8697 281.816 92.9057 281.816 90.423C281.816 87.9772 283.785 85.9762 286.273 85.9762C288.724 85.9762 290.729 87.9772 290.729 90.423ZM289.541 90.423C289.541 88.6442 288.055 87.162 286.273 87.162C284.453 87.162 283.005 88.6442 283.005 90.423C283.005 92.2387 284.453 93.6839 286.273 93.6839C288.055 93.6839 289.541 92.2387 289.541 90.423Z",
    fill: "white"
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    x: 9.50732,
    y: 9.45557,
    width: 95.0725,
    height: 4.6875,
    fill: "#E0E0E0"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbnail1A);
export default __webpack_public_path__ + "static/media/thumbnail-1-a.4b44647a559dd1c9349a88ed5d27e580.svg";
export { ForwardRef as ReactComponent };